<template>
    <div>
        <h2>My Cards</h2>
        <vs-divider/>
        <vs-card>
            <div v-if="cardsLoading">Loading cards...</div>
            <div v-if="cardsError">{{cardsError}}</div>
            
            <vs-table class="cards-table" v-if="hasCards" max-items="3" pagination :data="cards.data">
                <template v-slot:thead>
                    <vs-th>Brand</vs-th>
                    <vs-th>Last 4 digits</vs-th>
                    <vs-th>Exp month</vs-th>
                    <vs-th>Exp year</vs-th>
                    <vs-th>Card added at</vs-th>
                    <vs-th>Active on Subscription</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template v-slot="{data}">
                    <vs-tr v-for="method in data" :key="method.id">
                        <vs-td>{{method.card.brand}}</vs-td>
                        <vs-td>{{method.card.last4}}</vs-td>
                        <vs-td>{{method.card.exp_month}}</vs-td>
                        <vs-td>{{method.card.exp_year}}</vs-td>
                        <vs-td>{{formatDate(method.created)}}</vs-td>
                        <vs-td class="centered">
                            <feather-icon v-if="(activePaymentCard === method.id)" icon="CheckIcon" svgClasses="h-5 w-5 mb-1 stroke-current text-primary" />
                        </vs-td>
                        <vs-td>
                            <vs-chip v-if="activePaymentCard !== method.id" class="active" color="primary"><span style="color: #fff" @click="beforePaymentCardDelete(method)/*removeCard(method.id)*/">Remove</span></vs-chip>
                            <vs-chip v-else><span>Remove</span></vs-chip>

                            <vs-chip v-if="(activePaymentCard !== method.id && hasSubscriptions)" class="active" color="primary"><span style="color: #fff" @click="beforePaymentCardUpdate(method)">Set as Active</span></vs-chip>
                            <vs-chip v-else><span>Set as Active</span></vs-chip>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <div v-if="!hasCards && !cardsLoading && !cardsError">No cards found.</div>
            <div v-if="this.$store.state.AppActiveUser.stripe_id && hasSubscriptions && !addNewCard" class="vx-col md:w-1/2 mt-5">
                <vs-button
                    @click="addPaymentCard()"
                    color="primary"
                    type="filled"
                    class="customizer-btn">Add Payment Card</vs-button>
            </div>
        </vs-card>
        <vs-card v-if="addNewCard">
            <CardForm :dashboardView="true" @card-added="cardAdded" />
        </vs-card>

        <!-- POPUPS -->
        <vs-popup class="popup-confirm" title="Set Active Payment Card" :active.sync="setCardPopupActive">
            <div class="description" v-if="selectedPaymentMethod.card">Set {{selectedPaymentMethod.card.brand}} {{selectedPaymentMethod.card.last4}} as the default payment card for the active subscription?</div>
            <div class="action-wrapper">
                <vs-button
                    @click="() => {setCardPopupActive = false}"
                    color="light"
                    type="filled"
                    class="customizer-btn cancel"><span>Cancel</span></vs-button>
                <vs-button
                    @click="changeActivePaymentCard()"
                    color="primary"
                    type="filled"
                    class="customizer-btn confirm"><span>Confirm</span></vs-button>
            </div>
        </vs-popup>
        <vs-popup class="popup-confirm" title="Delete Payment Card" :active.sync="deleteCardPopupActive">
            <div class="description" v-if="selectedPaymentMethod.card">Are You sure to delete payment card: {{selectedPaymentMethod.card.brand}} {{selectedPaymentMethod.card.last4}}?</div>
            <div class="action-wrapper">
                <vs-button
                    @click="() => {deleteCardPopupActive = false}"
                    color="light"
                    type="filled"
                    class="customizer-btn cancel"><span>Cancel</span></vs-button>
                <vs-button
                    @click="deletePaymentCard()"
                    color="primary"
                    type="filled"
                    class="customizer-btn confirm"><span>Confirm</span></vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import helperMethods from '../mixins/helperMethods'
import CardForm from './components/card/CardForm'
import { 
    getStripeSubscriptions, 
    getStripeCards, 
    updateStripeSubscription, 
    detachPaymentMethodFromStripeCustomer 
} from '../stripe/stripeHelperMethods'

export default {
    name: 'Cards',
    components: {
        CardForm
    },
    mixins: [
        helperMethods
    ],
    data() {
        return {
            cards: {},
            hasCards: false,
            cardsLoading: false,
            cardsError: '',
            addNewCard: false,
            stripeCustomer: false,
            hasSubscriptions: false,
            selectedPaymentMethod: {},
            activePaymentCard: '',
            setCardPopupActive: false,
            deleteCardPopupActive: false,
            stripeSubscriptions: {}
        }
    },
    mounted() {
        this.stripeCustomer = this.$store.state.AppActiveUser.stripeCustomer
        this.hasSubscriptions = this.$store.state.AppActiveUser.hasSubscriptions
        this.stripeSubscriptions = this.$store.state.AppActiveUser.stripeSubscriptions
        // There should not be more than 1 subscription per customer
        this.activePaymentCard = this.stripeSubscriptions.data ? this.stripeSubscriptions.data[0].default_payment_method : ''

        // Get Cards from Stripe only if they have not been fetched already
        if (!this.hasData(this.$store.state.AppActiveUser.stripeCards) && this.$store.state.AppActiveUser.stripe_id) {
            this.loadCards(this.$store.state.AppActiveUser.stripe_id)
        } else {
            this.cards = this.$store.state.AppActiveUser.stripeCards;
            this.hasCards = this.hasData(this.cards)
        }
    },
    methods: {
        loadCards(stripeCustomerId) {
            this.cardsLoading = true;

            getStripeCards(stripeCustomerId)
                .then (result => {
                    //console.log('Cards GET result:', result)
                    this.cards = result.data;
                    this.hasCards = this.hasData(this.cards)
                    this.$store.commit('UPDATE_USER_INFO', { stripeCards: this.cards, hasCards: this.hasCards }, { root: true })
                }).catch(err => {
                    this.cardsError = 'Error occured while fetching cards: ' + err.response.data.raw.message;
                    this.hasCards = false;
                }).finally(() => {
                    this.cardsLoading = false;
                })
        },
        cardAdded(cards) {
            this.cards = cards
            this.addNewCard = false
        },
        beforePaymentCardUpdate(method) {
            this.selectedPaymentMethod = method
            this.setCardPopupActive = true
        },
        beforePaymentCardDelete(method) {
            this.selectedPaymentMethod = method
            this.deleteCardPopupActive = true
        },
        changeActivePaymentCard() {
            this.setCardPopupActive = false;
            this.$vs.loading()

            let updateProps = {
                // There should not be more than 1 subscription per customer
                subscription_id: this.stripeSubscriptions.data[0].id,
                default_payment_method: this.selectedPaymentMethod.id
            }

            updateStripeSubscription(updateProps)
                .then (() => {
                    //console.log('Update subscription POST result:', result)
                    
                    // Refresh the whole subs list
                    getStripeSubscriptions(this.$store.state.AppActiveUser.stripe_id)  
                        .then (result => {
                            //console.log('subscription GET result:', result)
                            this.stripeSubscriptions = (result.data.data && result.data.data.length > 0) ? result.data : {};
                            this.hasSubscriptions = this.hasData(this.stripeSubscriptions)
                            this.$store.commit('UPDATE_USER_INFO', { stripeSubscriptions: this.stripeSubscriptions, hasSubscriptions: this.hasSubscriptions }, { root: true })
                            this.activePaymentCard = this.selectedPaymentMethod.id
                            this.$vs.notify({
                                title: 'Plan subscription update',
                                text: 'Updated the selected subscription succesfully',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'success'
                            })
                        }).catch(err => {
                            this.hasSubscriptions = false
                            this.$vs.notify({
                                title: 'Plan subscription update',
                                text: 'Error occured while fetching updated subscriptions: ' + err.response.data.raw.message,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            })
                        })  
                }).catch(err => {
                    this.hasSubscriptions = false
                    this.$vs.notify({
                        title: 'Plan subscription update',
                        text: 'Error occured while fetching subscriptions: ' + err.response.data.raw.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }).finally(() => {
                    this.subsLoading = false
                    this.$vs.loading.close()
                })
        },
        deletePaymentCard() {
            this.deleteCardPopupActive = false;
            this.$vs.loading()
            
            detachPaymentMethodFromStripeCustomer(this.selectedPaymentMethod.id)
                .then (result => {
                    this.$store.commit('REMOVE_CARD', result.data, { root: true })
                    this.cards = this.$store.state.AppActiveUser.stripeCards
                    this.hasCards = this.hasData(this.cards)
                    this.$vs.notify({
                        title: 'Remove Payment Card',
                        text: 'Payment Card removed successfully!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'
                    })
                }).catch((err) => {
                    this.hasCards = false;
                    this.cardsError = 'Error occured while fetching cards: ' + err.response.data.raw.message;
                    this.$vs.notify({
                        title: 'Remove Payment Card',
                        text: this.cardsError,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }).finally(() => {
                    this.$vs.loading.close()
                })
        },
        addPaymentCard() {
            this.addNewCard = true;
        }
    }
}
</script>
<style scoped>
.cards-table td.centered {
    text-align: center;
}
.con-vs-chip {
    text-align: center;
}
.con-vs-chip.active :hover {
    cursor: pointer;
}
.popup-confirm .description {
    margin-bottom: 20px;
    font-weight: bold;
}
.popup-confirm .customizer-btn {
    margin: 0 10px;
}
.popup-confirm .customizer-btn.cancel {
    color: #6c6c6c;
}
.popup-confirm .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
</style>